export const InvictusFaqList = [
    {
        targetId: '1',
        heading: 'Q. What is Invictus Admission Test ?',
        subheading: 'Invictus Admission Test is a unique initiative by AAKASH, crafted to help students identify their current strengths, weaknesses, opportunities, and threats (SWOT), and gain clarity on their future path. It also provides a platform for students to showcase their hidden potential and earn exciting rewards.',
        bulletpoints: [],
    },
    {
        targetId: '2',
        heading: 'Q. What is the eligibility criteria for the Invictus Admission Test exam?',
        subheading: 'There is no specific eligibility criteria for the Invictus Admission Test program; it is open to all students currently studying in Grades 7th to 12th Studying and 12 passed.',
        bulletpoints: [],
    },
    {
        targetId: '3',
        heading: 'Q. How and when will the Test be conducted?',
        bulletpoints: [],
        subheading: 'Invictus Admission Test will be conducted in both offline mode and online mode. The test dates will be <strong>The test will be conducted in offline & Online mode every week</strong>',
    },
    {
        targetId: '4',
        heading:
            'Q. What are the Test timings for the Invictus Admission Test?',
        bulletpoints: [],
        subheading: 'The Invictus Admission Test will be held from 10:00 AM to 05:00 PM (window).',

    },
    {
        targetId: '5',
        heading: 'Q. How to Apply for Invictus Admission Test ?',
        bulletpoints: [],
        subheading: '<strong>For Online Registration:</strong><br/><ol><li>Visit: <a href="https://invictus.aakash.ac.in/invictus" style="color:#0000FF">https://invictus.aakash.ac.in/invictus</a></li><li>Enter your mobile number and verify via OTP, or use your PSID to register.</li><li>Fill in the required details such as name, contact number, class, stream, Test mode, etc.</li><li>Select your preferred Test date and time.</li><li>Make the payment and submit the form.</li></ol><strong>For Offline Registration:</strong><ol><li>Visit your nearest Aakash Centre.</li><li>Collect the Invictus Admission Test registration form from the center.</li><li>Fill out the form carefully, providing all required details.</li><li>Submit the completed form at the center.</li></ol>',
    },
    {
        targetId: '6',
        heading: 'Q. What is the Fees for the Invictus Admission Test ?',
        subheading: 'The fee for Invictus Admission Test is ₹100, and it remains the same for both online and offline modes.',
        bulletpoints: [],
    },
    {
        targetId: '7',
        heading: 'Q. What is the last Date of Registration?',
        subheading: '<strong>The last date for registration for Invictus Admission Test is:</strong><ul><li>Offline mode: 4 days before the exam day</li><li>	Online mode: Till the Date of exam.</li></ul>',
        bulletpoints: [],
    },
    {
        targetId: '8',
        heading: 'Q. When will I receive the result of the test ?',
        subheading: 'The result will be available in the next 5 days of the exam',//'<table style="width: 45%;text-align: center;"><tr><td><strong>Test Date<strong></td><td><strong>Result Declaration Date</strong></td></tr><tr><td>24th August 2025</td><td>30th August 2025</td></tr><tr><td>31st August 2025</td><td>6th September 2025</td></tr><tr><td>7th September 2025</td><td>13th September 2025</td></tr></table>',
        bulletpoints: [],

    },
    // {
    //     targetId: '9',
    //     heading: 'Q. Are there any practice tests available for Invictus Admission Test only preparation?',
    //     subheading: 'Yes, a sample test for Invictus Admission Test only is provided and will be shared via SMS/Email after registration.',
    //     bulletpoints: [],
    // },
    {
        targetId: '10',
        heading: 'Q. How can I Get more information about the Test?',
        subheading: 'For more information, please call us at 1800-102-2727 or email us at <a href="mailto:care@aesl.in" style="color:#0000FF">care@aesl.in</a>.',
        bulletpoints: [],
    },
    // {
    //     targetId: '11',
    //     heading: 'Q. What is the Test pattern and syllabus for the Invictus Admission Test only?',
    //     subheading: 'Please Referred to the Brochure - <a href="https://bit.ly/invictus-ace-brochure" style="color:#0000FF">https://bit.ly/invictus-ace-brochure</a>',
    //     bulletpoints: [],
    // },
]